import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const Rejected = ({
  onShowLiveChat,
  uploadDocuments,
  redirectToApps,
  showPOIDoc,
  showPOADoc,
  isDesktop
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Documents Rejected
      </div>
      <div className={styles.bold}>
        {'Thank you for submitting your documents. Unfortunately, we have not been able to accept some of the documents provided.'}
      </div>
      <div>
        <span>{'This may be due to the documents not being of high enough quality, or the information on those documents not matching the information we have on record for you.'}</span>
        <br />
        <br />
        <span>{'Please reupload the following documents:'}</span>
        {(showPOIDoc || showPOADoc) && (
          <ul className={styles.list}>
            {showPOIDoc && <li>Proof of Identity</li>}
            {showPOADoc && <li>Proof of Address</li>}
          </ul>
        )}
        <span>{'An email has been sent to your registered email address, outlining the information we require.'}</span>
        <br />
        <br />
        <span>{'If you have submitted the documents already via email, please do not resubmit your documents and await feedback from the Matchbook Compliance team.'}</span>
        <br />
        <br />
        <span>{'Our customer service team is on hand to help with your account via Live Chat.'}</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={onShowLiveChat}
      >Live Chat</Button>
      {isDesktop ? (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={uploadDocuments}
          className={styles.primaryButton}
        >Upload Documents</Button>
      ) : (
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={redirectToApps}
          className={styles.primaryButton}
        >Get the App</Button>
      )}
    </div>
  </Fragment>
);

Rejected.propTypes = {
  onShowLiveChat: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  redirectToApps: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  showPOIDoc: PropTypes.bool.isRequired,
  showPOADoc: PropTypes.bool.isRequired,
};

export default Rejected;

